import { handleError } from "../helpers/globalHandler";
import uuidv4 from "uuid/v4";
import Cookies from "cookies-js";

export const logAndylitics = (ActivityType, ActivityCode, ActivityStart, ActivityEnd, ActivityJSON, ActivityParam1, ActivityParam2, Url, UserID) => {
    try {
        let correlationId = Cookies.get("bsw-CorrelationId");
        let sessionId = Cookies.get("bsw-SessionId");
        if (typeof window !== "undefined") {
            if (typeof Url === "undefined" || Url === null || Url === "") {
                Url = window.location.href;
            }
            //const oState = window.store.getState();
            //if (oState && oState.domain) {
            const domain = window.store.getState().domain; //sessionStorage['root'] ? JSON.parse(JSON.parse(sessionStorage['root']).domain) : window.store.getState().domain;
            if (domain) {
                // here we want to keep the correlation id if it was generated from the SSO
                if (typeof correlationId === "undefined" || correlationId === null || correlationId === "") {
                    correlationId = domain.c; //oState.domain.c;
                }
                sessionId = domain.s; //oState.domain.s;
                // fill in userID if it wasn't passed in
                if (typeof UserID === "undefined" || UserID == null || UserID == "") {
                    UserID = domain.un; //oState.domain.un;
                }
            }
        }

        if (window.serverData.data.andyliticsActivityCodePrefix) {
            ActivityCode = window.serverData.data.andyliticsActivityCodePrefix + ActivityCode;
        }

        const payload = {
            ActivityType,
            ActivityCode,
            ActivityStart,
            ActivityEnd,
            ActivityDetailsJson: ActivityJSON ? JSON.stringify(ActivityJSON) : null,
            ActivityParam1,
            ActivityParam2,
            Url,
            UserName: UserID || window.currentUserName || null,
            ApplicationName: window.serverData.data.andyliticsApplicationName,
            Platform: window.serverData.data.browser,
            PlatformVersion: window.serverData.data.browserVersion,
            InstallationIdentifier: window.serverData.data.ipAddress,
            SessionId: sessionId,
            CorrelationId: correlationId,
            ApplicationVersion: window.serverData.data.applicationVersion
        };

        const fullUrl = window.serverData.data.andyliticsKey; // "/api/Andylitics/Log";
        //if (typeof correlationId === "undefined" || correlationId === null || correlationId === "") {
        //    debugger;
        //}
        //if (typeof sessionId === "undefined" || sessionId === null || sessionId === "") {
        //    debugger;
        //}
        const params = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json",
                "bsw-CorrelationId": correlationId,
                "bsw-SessionId": sessionId
            },
            body: JSON.stringify(payload),
            //mode: "no-cors"
        };

        return fetch(fullUrl, params).then(response => {
            if (handleError(response)) {
                return Promise.reject(response);
            }
            return response;
        }).then(ret => {
            return ret;
        });
    }
    catch (e) {
        console.error(e);
    }
};


export const log = (activityType, activityName, startTime, url, activityJsonData = null, activityParam1 = null, activityParam2 = null) => {
    logAndylitics(activityType, activityName, startTime, new Date(), activityJsonData, activityParam1, activityParam2, url, null);
};

export const logAPI = (activityName, startTime, url, activityJsonData = null, activityParam1 = null, activityParam2 = null) => {
    return log("WEB_API", activityName, startTime, url, activityJsonData, activityParam1, activityParam2);
}

export const logUI = (activityName, startTime, url, activityJsonData = null, activityParam1 = null, activityParam2 = null) => {
    return log("WEB_UI", activityName, startTime, url, activityJsonData, activityParam1, activityParam2);
}


export const logToAndylitics = (activityName, startTime, url) => {
    logAndylitics("WEB_API", activityName, startTime, new Date(), null, null, null, url, null);
};